import { v4 as uuidv4 } from 'uuid';

export function BackToTopButton(props = {}) {
	return {
		componentName: 'BackToTopButton',
		componentId: uuidv4(),
		props: Object.assign(
			{
				display: 'button',
				displayThreshold: 600,
			},
			props,
		),
		childrenComponents: [],
	};
}
